module.exports = __webpack_public_path__ + "static/media/nonprofit.94e75691.png";